module.exports = __webpack_public_path__ + "files/3caa4043798eeb322d22e1ca83dac739.png";